var map = {
	"./Center_Of_The_Body.svg": 749,
	"./Left_Leg.svg": 750,
	"./Left_Leg_-_With_Support.svg": 751,
	"./Right_Leg.svg": 752,
	"./Right_Leg_-_With_Support.svg": 753,
	"./Sitting_Left_Hand.svg": 754,
	"./Sitting_Right_Hand.svg": 755,
	"./Sitting_Two_Hands.svg": 756,
	"./Sitting_Two_Hands_Together.svg": 757,
	"./Standing_Left_Hand.svg": 758,
	"./Standing_Right_Hand.svg": 759,
	"./Standing_Right_Leg_-_With_Support.svg": 760,
	"./Standing_Two_Hands.svg": 761,
	"./Standing_Two_Hands_Together.svg": 762,
	"./Stepper_Two_Hands.svg": 763,
	"./Two_Legs.svg": 764,
	"./Two_Legs_-_With_Support.svg": 765,
	"./supProControllerLeft.svg": 766,
	"./supProControllerRight.svg": 767,
	"./supinationController.png": 768
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/position_icons nonrecursive \.(png|jpe?g|svg)$
// module id = 748
// module chunks = 0